document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.add('page-loaded');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const lerp = (start, end, amount) => start + (end - start) * amount;

  if (reduceMotion) {
    document.querySelectorAll('.reveal-luxury, .reveal-title').forEach((item) => {
      item.style.setProperty('--reveal-progress', '1');
    });
    return;
  }

  /* ===============================
     CONTINUOUS SCROLL REVEALS
  ================================= */
  const revealItems = Array.from(document.querySelectorAll('.reveal-luxury, .reveal-title')).map((el) => {
    const styles = getComputedStyle(el);
    const className = typeof el.className === 'string' ? el.className : '';

    return {
      el,
      current: 0,
      target: 0,
      offset: parseFloat(styles.getPropertyValue('--reveal-offset')) || 0,
      isProduct: el.classList.contains('product-card-luxury'),
      isTitle: el.classList.contains('reveal-title'),
      isFooter: className.includes('ai-multi-collection__footer-')
    };
  });

  /* ===============================
     HERO PARALLAX / PREMIUM SCROLL
  ================================= */
  const hero = document.querySelector('.hero-luxury-image');
  let heroSection = null;
  let nextSection = null;
  let heroCurrent = 0;
  let heroTarget = 0;

  if (hero) {
    heroSection = hero.closest('[id^="shopify-section-"]') || hero;
    nextSection = heroSection.nextElementSibling;

    while (nextSection && !nextSection.id?.startsWith('shopify-section-')) {
      nextSection = nextSection.nextElementSibling;
    }

    if (nextSection) {
      nextSection.classList.add('next-after-hero-luxury');
    }
  }

  let rafId = null;

  function updateTargets() {
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    const isMobile = window.innerWidth < 750;

    revealItems.forEach((item) => {
      const rect = item.el.getBoundingClientRect();

      let start = viewportH * 0.96;
      let end = viewportH * 0.30;

      if (item.isProduct) {
        start = viewportH * 0.97;
        end = viewportH * (isMobile ? 0.76 : 0.68);
      } else if (item.isFooter) {
        start = viewportH * 0.94;
        end = viewportH * (isMobile ? 0.58 : 0.52);
      } else if (item.isTitle) {
        start = viewportH * 0.94;
        end = viewportH * (isMobile ? 0.52 : 0.44);
      }

      const raw = clamp((start - rect.top) / (start - end), 0, 1);
      item.target = clamp((raw - item.offset) / (1 - item.offset), 0, 1);
    });

    if (heroSection) {
      const rect = heroSection.getBoundingClientRect();
      const heroHeight = Math.max(rect.height, 1);
      const startPoint = viewportH * (isMobile ? 0.05 : 0.09);

      heroTarget = clamp(
        (startPoint - rect.top) / (heroHeight * (isMobile ? 1.04 : 0.94)),
        0,
        1
      );
    }
  }

  function animate() {
    let keepAnimating = false;
    const isMobile = window.innerWidth < 750;
    const mobileFactor = isMobile ? 0.74 : 1;

    revealItems.forEach((item) => {
      const ease = item.isProduct ? 0.18 : 0.14;
      item.current = lerp(item.current, item.target, ease);

      if (Math.abs(item.target - item.current) < 0.0015) {
        item.current = item.target;
      } else {
        keepAnimating = true;
      }

      item.el.style.setProperty('--reveal-progress', item.current.toFixed(4));
    });

    if (heroSection && hero) {
      heroCurrent = lerp(heroCurrent, heroTarget, 0.08);

      if (Math.abs(heroTarget - heroCurrent) < 0.0015) {
        heroCurrent = heroTarget;
      } else {
        keepAnimating = true;
      }

      const progress = heroCurrent;

      /* blur starts after a tiny bit of scroll */
      const blurStart = 0.4;
      const blurProgress = clamp((progress - blurStart) / (1 - blurStart), 0, 1);

      /* image moves slower */
      const mediaY = progress * (-14 * mobileFactor);
      const mediaScale = 1.10 - (progress * 0.022);
      const mediaBlur = blurProgress * (1.35 * mobileFactor);

      /* text drifts upward gently */
      const textY = progress * (-22 * mobileFactor);
      const textOpacity = 1 - (progress * 0.50);
      const textBlur = blurProgress * (2.2 * mobileFactor);

      /* subtle luxury glass */
      const glassBlur = blurProgress * (10 * mobileFactor);
      const glassOpacity = 0.03 + (blurProgress * 0.08);

      /* products section rises a bit faster */
      const nextLift = progress * (30 * mobileFactor);

      hero.style.setProperty('--hero-media-y', `${mediaY.toFixed(2)}px`);
      hero.style.setProperty('--hero-media-scale', mediaScale.toFixed(4));
      hero.style.setProperty('--hero-media-blur', `${mediaBlur.toFixed(2)}px`);
      hero.style.setProperty('--hero-text-y', `${textY.toFixed(2)}px`);
      hero.style.setProperty('--hero-text-opacity', clamp(textOpacity, 0, 1).toFixed(4));
      hero.style.setProperty('--hero-text-blur', `${textBlur.toFixed(2)}px`);
      hero.style.setProperty('--hero-glass-blur', `${glassBlur.toFixed(2)}px`);
      hero.style.setProperty('--hero-glass-opacity', glassOpacity.toFixed(3));

      if (nextSection) {
        nextSection.style.setProperty('--hero-next-lift', `${nextLift.toFixed(2)}px`);
      }
    }

    if (keepAnimating) {
      rafId = window.requestAnimationFrame(animate);
    } else {
      rafId = null;
    }
  }

  function requestUpdate() {
    updateTargets();
    if (!rafId) {
      rafId = window.requestAnimationFrame(animate);
    }
  }

  requestUpdate();

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('orientationchange', requestUpdate);
  window.addEventListener('load', requestUpdate);
});